import DeviceComputerLine from './device-computer-line.component.js'

export * from './device-computer-line.component.js'
export default DeviceComputerLine

DeviceComputerLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-computer-line': DeviceComputerLine
  }
}
